import _, { compact, uniqBy } from 'lodash'
import { KPIMap } from '@/umcc/constant'
import dayjs from 'dayjs'

export const getBaseUrl = () => {
  const url = {
    mock: 'http://mock.ui.sandbox.fugetech.com/mock/5bab2b64fda472679e1d397f',
    development: 'http://umcc-dev.ui.sandbox.fugetech.com/api',
    default: '/api'
  }
  return url[process.env.NODE_ENV] || url.default
}

export const qs = url => _.chain(url)
  .replace('?', '')
  .split('&')
  .map(_.partial(_.split, _, '=', 2))
  .fromPairs()
  .value()

export const checkIsView = () => qs(location.search).status === 'completed'

export const numberWithCommas = (number, digit = 0, isDigit = true) => {
  if (number == null) return '—'
  const n = Number(number)
  if (Number.isNaN(n)) {
    return '—'
  }
  return isDigit ? n.toFixed(digit).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : String(n).includes('.') ? String(n).split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + String(n).split('.')[1]
      : String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const numberWithPercent = (number, digit = 0) => {
  const n = Number(number)
  if (Number.isNaN(n) || number == null) return '—'
  return (n * 100).toFixed(digit).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '%'
}

export const formatMoney = (v, b = 2) => {
  if (v == null) return '—'
  if (isNaN(Number(v))) return '—'
  const num = Math.abs(Number(v)).toFixed(b).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  if (v < 0) return '-￥' + num
  return '￥' + num
}

export const format4backend = obj => {
  let pairs = []

  const handleStringAndNumber = key => {
    pairs.push(`${key}=${encodeURIComponent(String(obj[key]))}`)
  }

  const handleArray = key => {
    if (Array.isArray(obj[key][0])) {
      obj[key].forEach((x, i) => {
        x = compact(x)
        x.forEach((y, j) => {
          for (let subKey of Object.keys(y)) {
            if (Array.isArray(y)) {
              y = compact(y)
              y.forEach((a, b) => {
                for (let subKey of Object.keys(a)) {
                  pairs.push(
                    `${key}[${i}][${j}][${b}].${subKey}=${encodeURIComponent(a[subKey])}`
                  )
                }
              })
            } else {
              pairs.push(
                `${key}[${i}][${j}].${subKey}=${encodeURIComponent(y[subKey])}`
              )
            }
          }
        })
      })
      return
    }
    obj[key].forEach((o, index) => {
      if (o == null) return
      for (let name of Object.keys(o)) {
        pairs.push(`${key}[${index}].${name}=${encodeURIComponent(o[name])}`)
      }
    })
  }

  const handleObj = key => {
    if (key == null) return
    for (let subKey of Object.keys(obj[key])) {
      if (obj[key][subKey] != null && obj[key][subKey] !== '') pairs.push(`${key}.${subKey}=${encodeURIComponent(obj[key][subKey])}`)
    }
  }

  const handleBoolean = key => {
    pairs.push(`${key}=${encodeURIComponent((obj[key]))}`)
  }

  for (let key of Object.keys(obj)) {
    switch (true) {
      case typeof obj[key] === 'string' || typeof obj[key] === 'number':
        handleStringAndNumber(key)
        break
      case Array.isArray(obj[key]):
        handleArray(key)
        break
      case typeof obj[key] === 'object' && obj[key] !== null:
        handleObj(key)
        break
      case typeof obj[key] === 'boolean':
        handleBoolean(key)
        break
      case typeof obj[key] === 'undefined' || obj[key] === null:
        break
      default:
        throw new Error("utils:obj2Params can't handle key type: " + key)
    }
  }
  return pairs.join('&')
}
export const IEVersion = () => {
  var userAgent = navigator.userAgent
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+)')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion === 7) {
      return 7
    } else if (fIEVersion === 8) {
      return 8
    } else if (fIEVersion === 9) {
      return 9
    } else if (fIEVersion === 10) {
      return 10
    } else {
      return 6
    }
  } else if (isEdge) {
    return 12
  } else if (isIE11) {
    return 11
  } else {
    return -1
  }
}
export const formatKPI = ({kpiId, kpiName}) => {
  if (kpiId) {
    return KPIMap.find(o => o.kpiId === kpiId).format
  }
  if (kpiName) {
    return KPIMap.find(o => o.kpiName === kpiName).format
  }
  return null
}

/**
 * formatCategory:
 * convert:
 * {
 *   category_id: 1,
 *   scope_id: 1
 * },
 * {
 *   category_id: 1,
 *   scope_id: 2
 * }
 * to:
 * {
 *   category_id: 1,
 *   category_name: '',
 *   children: [
 *     {
 *       scope_id: 1,
 *       scope_name: ''
 *     },
 *     {
 *       scope_id: 2,
 *       scope_name: ''
 *     }
 *   ]
 * }
 **/
export const formatCategory = (category) => {
  const arr = uniqBy(category.map(i => i.category_id))
    .map(v => { return {category_id: v, children: []} })
  for (let j = 0; j < category.length; j++) {
    for (let i = 0; i < arr.length; i++) {
      if (category[j].category_id === arr[i].category_id) {
        arr[i].category_name = category[j].category_name
        arr[i].category_name_ch = category[j].category_name_ch
        if (category[j].scope_id) {
          arr[i].children.push({
            scope_name: category[j].scope_name,
            scope_id: category[j].scope_id,
            scope_name_ch: category[j].scope_name_ch
          })
        }
      }
    }
  }
  return arr
}

export const validateSelectedCategory = (categories) => {
  const arr = formatCategory(categories)
  let result = true
  for (let i = 0; i < arr.length; i++) {
    if (Number(arr[i].category_id) === 1 || Number(arr[i].category_id) === 2 || Number(arr[i].category_id) === 4) {
      if (arr[i].children.length === 0) {
        result = false
        break
      }
    }
  }
  return result
}

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const canvas2file = (canvas, fileName = 'default.png') => {
  const blobBin = atob(canvas.toDataURL().split(',')[1])
  const array = []
  for (let i = 0; i < blobBin.length; i++) {
    array.push(blobBin.charCodeAt(i))
  }
  const blob = new Blob([new Uint8Array(array)], { type: 'image/png' })
  return new File([blob], fileName)
}

export const dateFormatter = date => {
  if (date == null) return '—'
  return dayjs(date).format('YYYY/MM/DD HH:mm')
}

export const formatDate = date => {
  if (date == null) return '—'
  return dayjs(date).format('YYYY/MM/DD')
}

export const formatMonthDate = date => {
  if (date == null) return '—'
  return dayjs(date).format('YYYY/MM')
}

export const checkIsNonnegativeInteger = value => {
  if (Number.isInteger(Number(value)) && Number(value) >= 0) return true
  return false
}

export const formatRate = value => {
  if (value == null) return 0
  return value.toFixed(1) || 0
}

export const numMulti = (num1, num2) => {
  var baseNum = 0
  try {
    baseNum += num1.toString().split('.')[1].length
  } catch (e) {
  }
  try {
    baseNum += num2.toString().split('.')[1].length
  } catch (e) {
  }
  return Number(num1.toString().replace('.', '')) * Number(num2.toString().replace('.', '')) / Math.pow(10, baseNum)
}
